import './ie-polyfill';

import '@webcomponents/webcomponentsjs/webcomponents-bundle';
import '@webcomponents/webcomponentsjs/custom-elements-es5-adapter';

import AccordionComponent from './components/accordion';
import DrawerComponent from './components/drawer';
import ExampleComponent from './components/example';
import ModalComponent from './components/modal';
import NotificationComponent from './components/notification';
import SelectComponent from './components/select';
import UploaderComponent from './components/uploader';
import PhoneNumberComponent from './components/phone';
import EmailComponent from './components/email';
import LinkedSVG from './components/linkedSvg';
import Footer from './components/footer';

/**
 * customElements.define only accepts unique constructor
 * so we inherit each component so they can be used for backward compatibility definitions
 */
class EdlioAccordionComponent extends AccordionComponent {}
class EdlioDrawerComponent extends DrawerComponent {}
class EdlioModalComponent extends ModalComponent {}
class EdlioNotificationComponent extends NotificationComponent {}
class EdlioSelectComponent extends SelectComponent {}

main();

spike();

function main () {
    if (!window.customElements) {
        console.error('Failed to detect window.customElements. Did you import webcomponents polyfill?');
        return;
    }
    // Backward compatibility definition
    window.customElements.define('edlio-accordion', EdlioAccordionComponent);
    window.customElements.define('edlio-drawer', EdlioDrawerComponent);
    window.customElements.define('edlio-modal', EdlioModalComponent);
    window.customElements.define('edlio-notification', EdlioNotificationComponent);
    window.customElements.define('edlio-select', EdlioSelectComponent);
    
    window.customElements.define('uniform-accordion', AccordionComponent);
    window.customElements.define('uniform-drawer', DrawerComponent);
    window.customElements.define('uniform-example', ExampleComponent);
    window.customElements.define('uniform-modal', ModalComponent);
    window.customElements.define('uniform-notification', NotificationComponent);
    window.customElements.define('uniform-select', SelectComponent);
    window.customElements.define('uniform-uploader', UploaderComponent);
    window.customElements.define('uniform-phone-number', PhoneNumberComponent);
    window.customElements.define('uniform-email', EmailComponent);
    window.customElements.define('uniform-linked-svg', LinkedSVG);
    window.customElements.define('uniform-footer', Footer);
}

function spike() {
    const spike = `%c
        '                        
       ';'                        
      ;;; .,;;                    
     ;;;;;;;;:                    
 ; :;;;;;;;;;  ,                  
';;;;;;;;;;;;;;;                  
';;;;;;;;;;;;;;;                  
.;;;;;    .;;;;;                  
,;;;;      .;;;;                  
:;;;:       ;;;;                  
;;;;'       ;;;;                  
;;;;'       ;;;;                  
,;;;;       ;;;;                  
 ;;;;.     ;;;;;                  
 ;;;;;;' .;;;;;' .;;;;;;;;        
  ;;;;;;;;;;;;; ;;;;;;;;;;;;      
   ;;;;;;;;;;; ;;;;;;;;;;;;;;'    
    ;;;;;;;;: ;;;;;;;;;;;;;;;;'   
      ,;;;. ,;;;;;;;;;;;;;;;;;;   
          ;;;;;;;;;;;;;;;;;;;;;;  
          ;;;;;;;;;     ';;;;;;;, 
          ;;;;;;;,        ;;;;;;; 
          ;;;;;;;          ;;;;;; 
          ;;;;;;           ;;;;;;,
          ;;;;;;           ';;;;;:
          ;;;;;;            ;;;;;;
    `

    console.log(spike, 'color: #d22630');
}


// WEBPACK FOOTER //
// ./src/js/app.js